import { render, staticRenderFns } from "./AppInit.vue?vue&type=template&id=7ed86cf7&"
import script from "./AppInit.vue?vue&type=script&lang=js&"
export * from "./AppInit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports